import ChartWrapper from './ChartWrapper';
import { ChartWrapperProps } from './ChartWrapper.types';

function MixedChart({
  height = 300,
  width = '100%',
  options,
  series,
  ...rest
}: ChartWrapperProps) {
  return (
    <ChartWrapper
      width={width}
      height={height}
      type="line"
      options={options ?? {}}
      series={series ?? []}
      {...rest}
    />
  );
}
export default MixedChart;
